import { selectRowData } from '../store/slice'
import Row from './Row'

export const TBodyCustom = ({ ids, schema, isDynamic }) => {
  return (
    <tbody>
      {ids.map((rowId, rowIndex) => {
        return (
          <Row
            key={rowId}
            rowId={rowId}
            schema={schema}
            rowIndex={rowIndex}
            selectRowData={selectRowData}
            isDynamic={isDynamic}
          />
        )
      })}
    </tbody>
  )
}
